import FormSurvey from '@/components/FormSurvey'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: FormSurvey,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}
